export default __webpack_public_path__ + "static/media/5B4_Bobbins by Craig Holmes.a85de9fb.jpg";